import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { ServicioAutenticacion } from '../auth/auth.service';
import { ApiService } from '../services/api.service';
import { LoadingService } from '../services/loading.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class ComponenteLogin implements OnInit {
  nombreUsuario: string = '';
  contrasena: string = '';
  mensajeError: string = '';
  entorno: string = '';
  mostrarEntorno: boolean = false;
  constructor(
    private http: HttpClient,
    private router: Router,
    private servicioAutenticacion: ServicioAutenticacion,
    private apiSrv: ApiService,
    private loadingSrv: LoadingService
  ) {}
  ngOnInit(): void {
    this.servicioAutenticacion.estaAutenticado().subscribe((autenticado) => {
      if (autenticado) {
        this.router.navigate(['/home']);
        return;
      }
    });

    // Determinar el entorno
    if (environment.development) {
      this.entorno = 'DEV';
      this.mostrarEntorno = true;
    } else if (environment.testing) {
      this.entorno = 'TEST';
      this.mostrarEntorno = true;
    } else {
      // En producción no mostramos el entorno
      this.mostrarEntorno = false;
    }
  }

  iniciarSesion() {
    const credenciales = {
      usuario: btoa(this.nombreUsuario),
      password: btoa(this.contrasena),
    };

    this.mensajeError = '';

    this.http
      .post<any>(`${this.apiSrv.urlWeb}/usuarios/credencialWeb`, credenciales)
      .subscribe(
        (respuesta) => {
          if (respuesta.token) {
            this.servicioAutenticacion.iniciarSesion(respuesta.token);
            this.apiSrv.guardarUsuario({
              nombreCompleto: respuesta.usuario,
              roles: respuesta.roles,
            });
            this.mensajeError = '';

            // Activar loading inmediatamente antes de navegar para evitar que el usuario pueda interactuar
            this.loadingSrv.setLoading(true);
            this.router.navigate(['/home']);
          } else {
            this.mensajeError = 'Usuario y/o contraseña inválidos.';
          }
        },
        (error) => {
          this.mensajeError = 'Error en el inicio de sesión.';
        }
      );
  }
}
